import {
    CompleteMultipartUploadCommandOutput,
    DeleteObjectCommand,
    DeleteObjectCommandOutput,
    GetObjectCommand,
    ListObjectsV2Command,
    ListObjectsV2CommandOutput,
    S3Client,
} from '@aws-sdk/client-s3'
import { GetObjectCommandOutput } from '@aws-sdk/client-s3/dist-types/commands/GetObjectCommand'

import { getS3Client, multipartUpload } from 'src/services/aws/s3'

export class S3Handler {
    readonly s3BucketName: string
    private _client: S3Client | null = null

    constructor(s3BucketName: string) {
        this.s3BucketName = s3BucketName
    }

    private async getClient() {
        if (!this._client) {
            this._client = await getS3Client()
        }
        return this._client
    }

    async uploadJSONFileToS3(
        fileName: string,
        file: File | string
    ): Promise<CompleteMultipartUploadCommandOutput> {
        return await multipartUpload(await this.getClient(), file, {
            Bucket: this.s3BucketName,
            Key: fileName,
            ContentType: 'application/json',
        })
    }

    async deleteFileFromS3(fileName: string): Promise<DeleteObjectCommandOutput> {
        const client = await this.getClient()
        return await client.send(
            new DeleteObjectCommand({
                Bucket: this.s3BucketName,
                Key: fileName,
            })
        )
    }

    async getFileNames(): Promise<ListObjectsV2CommandOutput> {
        const client = await this.getClient()
        return await client.send(
            new ListObjectsV2Command({
                Bucket: this.s3BucketName,
            })
        )
    }

    async loadFileFromS3(fileName: string): Promise<GetObjectCommandOutput> {
        const client = await this.getClient()
        return await client.send(
            new GetObjectCommand({
                Bucket: this.s3BucketName,
                Key: fileName,
            })
        )
    }
}
